// extracted by mini-css-extract-plugin
module.exports = {"pwgbBanner":"PwGBBanner-module__pwgbBanner___2cGcI"};